module.exports = __webpack_public_path__ + "img/banner3.ce772ad8.jpg";